export var CarsTripCategory;
(function (CarsTripCategory) {
    CarsTripCategory["DIFFERENT_DROP_OFF"] = "different_drop_off";
    CarsTripCategory["SAME_AS_DROP_OFF"] = "same_as_drop_off";
})(CarsTripCategory || (CarsTripCategory = {}));
export var CarsAvailabilityRequestEnum;
(function (CarsAvailabilityRequestEnum) {
    CarsAvailabilityRequestEnum["FollowUpSearch"] = "FollowUpSearch";
    CarsAvailabilityRequestEnum["InitialSearch"] = "InitialSearch";
})(CarsAvailabilityRequestEnum || (CarsAvailabilityRequestEnum = {}));
export var CarsAvailabilityResponseEnum;
(function (CarsAvailabilityResponseEnum) {
    CarsAvailabilityResponseEnum["Results"] = "Results";
})(CarsAvailabilityResponseEnum || (CarsAvailabilityResponseEnum = {}));
export var CarsCancellationPolicyEnum;
(function (CarsCancellationPolicyEnum) {
    CarsCancellationPolicyEnum["FreeCancellation"] = "FreeCancellation";
    CarsCancellationPolicyEnum["NonRefundable"] = "NonRefundable";
    CarsCancellationPolicyEnum["PartiallyRefundable"] = "PartiallyRefundable";
    CarsCancellationPolicyEnum["Conditional"] = "Conditional";
    CarsCancellationPolicyEnum["ConditionalAfterBooking"] = "ConditionalAfterBooking";
})(CarsCancellationPolicyEnum || (CarsCancellationPolicyEnum = {}));
export var GroundSelectionEnum;
(function (GroundSelectionEnum) {
    GroundSelectionEnum["Location"] = "Location";
    GroundSelectionEnum["Place"] = "Place";
})(GroundSelectionEnum || (GroundSelectionEnum = {}));
export var AvailabilityFilterEnum;
(function (AvailabilityFilterEnum) {
    AvailabilityFilterEnum["VehicleIdFilter"] = "VehicleIdFilter";
})(AvailabilityFilterEnum || (AvailabilityFilterEnum = {}));
export var PickUpType;
(function (PickUpType) {
    PickUpType["Airport"] = "Airport";
    PickUpType["Shuttle"] = "Shuttle";
    PickUpType["MeetAndGreet"] = "MeetAndGreet";
})(PickUpType || (PickUpType = {}));
export var TransmissionTypeEnum;
(function (TransmissionTypeEnum) {
    TransmissionTypeEnum["Automatic"] = "Automatic";
    TransmissionTypeEnum["Cvt"] = "Cvt";
    TransmissionTypeEnum["Manual"] = "Manual";
})(TransmissionTypeEnum || (TransmissionTypeEnum = {}));
export var ImageKind;
(function (ImageKind) {
    ImageKind["Original"] = "original";
    ImageKind["Large"] = "large";
    ImageKind["Small"] = "small";
    ImageKind["Illustration"] = "illustration";
})(ImageKind || (ImageKind = {}));
export var BagSize;
(function (BagSize) {
    BagSize["Big"] = "Big";
    BagSize["Medium"] = "Medium";
    BagSize["Small"] = "Small";
    BagSize["Unspecified"] = "Unspecified";
})(BagSize || (BagSize = {}));
export var FuelPolicyKind;
(function (FuelPolicyKind) {
    FuelPolicyKind["PrepayRefunds"] = "PrepayRefunds";
    FuelPolicyKind["PrepayNoRefunds"] = "PrepayNoRefunds";
    FuelPolicyKind["FreeTank"] = "FreeTank";
    FuelPolicyKind["Unknown"] = "Unknown";
    FuelPolicyKind["ReturnSame"] = "ReturnSame";
    FuelPolicyKind["FullToFull"] = "FullToFull";
    FuelPolicyKind["MultipleOptionsAtDesk"] = "MultipleOptionsAtDesk";
})(FuelPolicyKind || (FuelPolicyKind = {}));
export var VehicleKindEnum;
(function (VehicleKindEnum) {
    VehicleKindEnum["Truck"] = "Truck";
    VehicleKindEnum["Small"] = "Small";
    VehicleKindEnum["Mystery"] = "Mystery";
    VehicleKindEnum["SUV"] = "SUV";
    VehicleKindEnum["Mini"] = "Mini";
    VehicleKindEnum["Intermediate"] = "Intermediate";
    VehicleKindEnum["Van"] = "Van";
    VehicleKindEnum["Luxury"] = "Luxury";
    VehicleKindEnum["FullSize"] = "FullSize";
    VehicleKindEnum["Compact"] = "Compact";
    VehicleKindEnum["Economy"] = "Economy";
    VehicleKindEnum["Standard"] = "Standard";
    VehicleKindEnum["SuppliersChoice"] = "SuppliersChoice";
})(VehicleKindEnum || (VehicleKindEnum = {}));
export var VehicleKindEnumV5;
(function (VehicleKindEnumV5) {
    VehicleKindEnumV5["CompactCar"] = "CompactCar";
    VehicleKindEnumV5["CompactCommercialVanTruck"] = "CompactCommercialVanTruck";
    VehicleKindEnumV5["CompactConvertible"] = "CompactConvertible";
    VehicleKindEnumV5["CompactCrossover"] = "CompactCrossover";
    VehicleKindEnumV5["CompactElectricSUV"] = "CompactElectricSUV";
    VehicleKindEnumV5["CompactElectricVan"] = "CompactElectricVan";
    VehicleKindEnumV5["CompactEliteCar"] = "CompactEliteCar";
    VehicleKindEnumV5["CompactEliteCoupe"] = "CompactEliteCoupe";
    VehicleKindEnumV5["CompactEliteCrossover"] = "CompactEliteCrossover";
    VehicleKindEnumV5["CompactEliteElectricCrossover"] = "CompactEliteElectricCrossover";
    VehicleKindEnumV5["CompactEliteSportsCar"] = "CompactEliteSportsCar";
    VehicleKindEnumV5["CompactEliteSUV"] = "CompactEliteSUV";
    VehicleKindEnumV5["CompactHybridCar"] = "CompactHybridCar";
    VehicleKindEnumV5["CompactRecreationalVehicle"] = "CompactRecreationalVehicle";
    VehicleKindEnumV5["CompactSUV"] = "CompactSUV";
    VehicleKindEnumV5["CompactVan"] = "CompactVan";
    VehicleKindEnumV5["EconomyCar"] = "EconomyCar";
    VehicleKindEnumV5["EconomyCrossover"] = "EconomyCrossover";
    VehicleKindEnumV5["EconomyEliteCar"] = "EconomyEliteCar";
    VehicleKindEnumV5["EconomyHybridSUV"] = "EconomyHybridSUV";
    VehicleKindEnumV5["EconomySpecial"] = "EconomySpecial";
    VehicleKindEnumV5["EconomySUV"] = "EconomySUV";
    VehicleKindEnumV5["FullSize2WheelVehicle"] = "FullSize2WheelVehicle";
    VehicleKindEnumV5["FullSizeCar"] = "FullSizeCar";
    VehicleKindEnumV5["FullSizeCrossover"] = "FullSizeCrossover";
    VehicleKindEnumV5["FullSizeElectricCar"] = "FullSizeElectricCar";
    VehicleKindEnumV5["FullSizeElite2WheelVehicle"] = "FullSizeElite2WheelVehicle";
    VehicleKindEnumV5["FullSizeEliteCar"] = "FullSizeEliteCar";
    VehicleKindEnumV5["FullSizeEliteSUV"] = "FullSizeEliteSUV";
    VehicleKindEnumV5["FullSizeEliteVan"] = "FullSizeEliteVan";
    VehicleKindEnumV5["FullSizeHybridCar"] = "FullSizeHybridCar";
    VehicleKindEnumV5["FullSizeOpenAirAllTerrain"] = "FullSizeOpenAirAllTerrain";
    VehicleKindEnumV5["FullSizePickupTruck"] = "FullSizePickupTruck";
    VehicleKindEnumV5["FullSizePickupTruckWithExtendedCab"] = "FullSizePickupTruckWithExtendedCab";
    VehicleKindEnumV5["FullSizeRecreationalVehicle"] = "FullSizeRecreationalVehicle";
    VehicleKindEnumV5["FullSizeSpecial"] = "FullSizeSpecial";
    VehicleKindEnumV5["FullSizeSportsCar"] = "FullSizeSportsCar";
    VehicleKindEnumV5["FullSizeSUV"] = "FullSizeSUV";
    VehicleKindEnumV5["FullSizeVan"] = "FullSizeVan";
    VehicleKindEnumV5["FullSizeWagon"] = "FullSizeWagon";
    VehicleKindEnumV5["Luxury2WheelVehicle"] = "Luxury2WheelVehicle";
    VehicleKindEnumV5["LuxuryCar"] = "LuxuryCar";
    VehicleKindEnumV5["LuxuryConvertible"] = "LuxuryConvertible";
    VehicleKindEnumV5["LuxuryCrossover"] = "LuxuryCrossover";
    VehicleKindEnumV5["LuxuryElectricSUV"] = "LuxuryElectricSUV";
    VehicleKindEnumV5["LuxuryEliteCar"] = "LuxuryEliteCar";
    VehicleKindEnumV5["LuxuryEliteElectricCar"] = "LuxuryEliteElectricCar";
    VehicleKindEnumV5["LuxuryEliteSpecial"] = "LuxuryEliteSpecial";
    VehicleKindEnumV5["LuxuryEliteSportsCar"] = "LuxuryEliteSportsCar";
    VehicleKindEnumV5["LuxuryEliteSUV"] = "LuxuryEliteSUV";
    VehicleKindEnumV5["LuxurySpecial"] = "LuxurySpecial";
    VehicleKindEnumV5["LuxurySportsCar"] = "LuxurySportsCar";
    VehicleKindEnumV5["LuxurySUV"] = "LuxurySUV";
    VehicleKindEnumV5["MidSizeCar"] = "MidSizeCar";
    VehicleKindEnumV5["MidSizeCommercialVanTruck"] = "MidSizeCommercialVanTruck";
    VehicleKindEnumV5["MidSizeConvertible"] = "MidSizeConvertible";
    VehicleKindEnumV5["MidSizeCrossover"] = "MidSizeCrossover";
    VehicleKindEnumV5["MidSizeElectricCar"] = "MidSizeElectricCar";
    VehicleKindEnumV5["MidSizeElectricSUV"] = "MidSizeElectricSUV";
    VehicleKindEnumV5["MidSizeEliteCar"] = "MidSizeEliteCar";
    VehicleKindEnumV5["MidSizeEliteConvertible"] = "MidSizeEliteConvertible";
    VehicleKindEnumV5["MidSizeEliteCrossover"] = "MidSizeEliteCrossover";
    VehicleKindEnumV5["MidSizeEliteElectricCar"] = "MidSizeEliteElectricCar";
    VehicleKindEnumV5["MidSizeEliteElectricCrossover"] = "MidSizeEliteElectricCrossover";
    VehicleKindEnumV5["MidSizeEliteSportsCar"] = "MidSizeEliteSportsCar";
    VehicleKindEnumV5["MidSizeEliteSUV"] = "MidSizeEliteSUV";
    VehicleKindEnumV5["MidSizeHybridCar"] = "MidSizeHybridCar";
    VehicleKindEnumV5["MidSizeLimousine"] = "MidSizeLimousine";
    VehicleKindEnumV5["MidSizeOpenAirAllTerrain"] = "MidSizeOpenAirAllTerrain";
    VehicleKindEnumV5["MidSizePickupTruck"] = "MidSizePickupTruck";
    VehicleKindEnumV5["MidSizeSpecial"] = "MidSizeSpecial";
    VehicleKindEnumV5["MidSizeSUV"] = "MidSizeSUV";
    VehicleKindEnumV5["MidSizeVan"] = "MidSizeVan";
    VehicleKindEnumV5["MiniCar"] = "MiniCar";
    VehicleKindEnumV5["MiniEliteVan"] = "MiniEliteVan";
    VehicleKindEnumV5["MiniSUV"] = "MiniSUV";
    VehicleKindEnumV5["MiniVan"] = "MiniVan";
    VehicleKindEnumV5["MysteryCar"] = "MysteryCar";
    VehicleKindEnumV5["OverSizePickupTruckWithExtendedCab"] = "OverSizePickupTruckWithExtendedCab";
    VehicleKindEnumV5["OverSizeVan"] = "OverSizeVan";
    VehicleKindEnumV5["Premium2WheelVehicle"] = "Premium2WheelVehicle";
    VehicleKindEnumV5["PremiumCar"] = "PremiumCar";
    VehicleKindEnumV5["PremiumConvertible"] = "PremiumConvertible";
    VehicleKindEnumV5["PremiumCrossover"] = "PremiumCrossover";
    VehicleKindEnumV5["PremiumElectricCar"] = "PremiumElectricCar";
    VehicleKindEnumV5["PremiumEliteConvertible"] = "PremiumEliteConvertible";
    VehicleKindEnumV5["PremiumEliteCrossover"] = "PremiumEliteCrossover";
    VehicleKindEnumV5["PremiumEliteSportsCar"] = "PremiumEliteSportsCar";
    VehicleKindEnumV5["PremiumEliteSUV"] = "PremiumEliteSUV";
    VehicleKindEnumV5["PremiumEliteVan"] = "PremiumEliteVan";
    VehicleKindEnumV5["PremiumLimousine"] = "PremiumLimousine";
    VehicleKindEnumV5["PremiumPickupTruck"] = "PremiumPickupTruck";
    VehicleKindEnumV5["PremiumPickupTruckWithExtendedCab"] = "PremiumPickupTruckWithExtendedCab";
    VehicleKindEnumV5["PremiumSportsCar"] = "PremiumSportsCar";
    VehicleKindEnumV5["PremiumSUV"] = "PremiumSUV";
    VehicleKindEnumV5["PremiumVan"] = "PremiumVan";
    VehicleKindEnumV5["PremiumWagon"] = "PremiumWagon";
    VehicleKindEnumV5["SpecialCar"] = "SpecialCar";
    VehicleKindEnumV5["SpecialConvertible"] = "SpecialConvertible";
    VehicleKindEnumV5["SpecialSportsCar"] = "SpecialSportsCar";
    VehicleKindEnumV5["SpecialSUV"] = "SpecialSUV";
    VehicleKindEnumV5["SpecialVan"] = "SpecialVan";
    VehicleKindEnumV5["Standard2WheelVehicle"] = "Standard2WheelVehicle";
    VehicleKindEnumV5["StandardCar"] = "StandardCar";
    VehicleKindEnumV5["StandardCommercialVanTruck"] = "StandardCommercialVanTruck";
    VehicleKindEnumV5["StandardConvertible"] = "StandardConvertible";
    VehicleKindEnumV5["StandardCoupe"] = "StandardCoupe";
    VehicleKindEnumV5["StandardCrossover"] = "StandardCrossover";
    VehicleKindEnumV5["StandardElectricCar"] = "StandardElectricCar";
    VehicleKindEnumV5["StandardEliteCar"] = "StandardEliteCar";
    VehicleKindEnumV5["StandardEliteCoupe"] = "StandardEliteCoupe";
    VehicleKindEnumV5["StandardEliteCrossover"] = "StandardEliteCrossover";
    VehicleKindEnumV5["StandardEliteElectricSUV"] = "StandardEliteElectricSUV";
    VehicleKindEnumV5["StandardEliteSportsCar"] = "StandardEliteSportsCar";
    VehicleKindEnumV5["StandardEliteSUV"] = "StandardEliteSUV";
    VehicleKindEnumV5["StandardEliteVan"] = "StandardEliteVan";
    VehicleKindEnumV5["StandardHybridCar"] = "StandardHybridCar";
    VehicleKindEnumV5["StandardHybridSUV"] = "StandardHybridSUV";
    VehicleKindEnumV5["StandardOpenAirAllTerrain"] = "StandardOpenAirAllTerrain";
    VehicleKindEnumV5["StandardPickupTruck"] = "StandardPickupTruck";
    VehicleKindEnumV5["StandardPickupTruckWithExtendedCab"] = "StandardPickupTruckWithExtendedCab";
    VehicleKindEnumV5["StandardRecreationalVehicle"] = "StandardRecreationalVehicle";
    VehicleKindEnumV5["StandardSportsCar"] = "StandardSportsCar";
    VehicleKindEnumV5["StandardSUV"] = "StandardSUV";
    VehicleKindEnumV5["StandardVan"] = "StandardVan";
})(VehicleKindEnumV5 || (VehicleKindEnumV5 = {}));
var Category;
(function (Category) {
    Category["Airports"] = "Airports";
    Category["Cities"] = "Cities";
    Category["HotelMarkets"] = "HotelMarkets";
    Category["Places"] = "Places";
    Category["RecentSearches"] = "RecentSearches";
    Category["EmptyMatch"] = "EmptyMatch";
})(Category || (Category = {}));
export var ChargeKind;
(function (ChargeKind) {
    ChargeKind["Extra"] = "Extra";
    ChargeKind["ExtraDaily"] = "ExtraDaily";
    ChargeKind["ExtraOriginal"] = "ExtraOriginal";
    ChargeKind["TotalWithExtra"] = "TotalWithExtra";
})(ChargeKind || (ChargeKind = {}));
export var LinkKind;
(function (LinkKind) {
    LinkKind["PostBookingPolicyWordingURI"] = "PostBookingPolicyWordingURI";
    LinkKind["PreBookingPolicyWordingURI"] = "PreBookingPolicyWordingURI";
    LinkKind["PostBookingKeyFactsURI"] = "PostBookingKeyFactsURI";
    LinkKind["PreBookingKeyFactsURI"] = "PreBookingKeyFactsURI";
    LinkKind["PostBookingDIPDanniCertificate"] = "PostBookingDIPDanniCertificate";
    LinkKind["PreBookingDIPDanniCertificate"] = "PreBookingDIPDanniCertificate";
    LinkKind["PostBookingCertificateURI"] = "PostBookingCertificateURI";
})(LinkKind || (LinkKind = {}));
export var ShopResponseElementKind;
(function (ShopResponseElementKind) {
    ShopResponseElementKind["Other"] = "Other";
    ShopResponseElementKind["InsuranceExternal"] = "InsuranceExternal";
    ShopResponseElementKind["Amenities"] = "Amenities";
    ShopResponseElementKind["ExtraDriver"] = "ExtraDriver";
    ShopResponseElementKind["BabyOnBoard"] = "BabyOnBoard";
    ShopResponseElementKind["General"] = "General";
    ShopResponseElementKind["Insurance"] = "Insurance";
})(ShopResponseElementKind || (ShopResponseElementKind = {}));
export var CarsBookErrorEnum;
(function (CarsBookErrorEnum) {
    CarsBookErrorEnum["InvalidLoyaltyNumber"] = "InvalidLoyaltyNumber";
    CarsBookErrorEnum["LoyaltyNameMismatch"] = "LoyaltyNameMismatch";
    CarsBookErrorEnum["DollarExpressNotFound"] = "DollarExpressNotFound";
    CarsBookErrorEnum["BlueChipNumberNotFound"] = "BlueChipNumberNotFound";
})(CarsBookErrorEnum || (CarsBookErrorEnum = {}));
export var CarEntryTypeEnum;
(function (CarEntryTypeEnum) {
    CarEntryTypeEnum["RECENTLY_SEARCHED_CAR"] = "recently_searched_car";
    CarEntryTypeEnum["RECENTLY_SEARCH_AUTOCOMPLETE"] = "recently_searched_autocomplete";
    CarEntryTypeEnum["TRAVEL_SALE_LANDING"] = "travel_sale_landing";
    CarEntryTypeEnum["TRAVEL_SALE_HOMEPAGE"] = "travel_sale_homepage";
    CarEntryTypeEnum["CROSS_SELL_STAYS_CONFIRMATION"] = "cross_sell_stays_confirmation";
})(CarEntryTypeEnum || (CarEntryTypeEnum = {}));
export function parseCarEntryType(value) {
    return Object.values(CarEntryTypeEnum).includes(value)
        ? value
        : undefined;
}
//# sourceMappingURL=interfaces.js.map